export default __webpack_public_path__ + "static/media/add.955a0b3e.svg";